import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiTrendingUp,FiZap,FiTarget,FiCheck,FiArrowRight,FiBook,FiUsers,FiAward,FiStar,FiBriefcase}=FiIcons;

function BusinessTraining() {
  const programs=[ 
    {icon: FiBriefcase,title: 'Digital Business Mastery Certification',duration: '8-week intensive program',format: [ 
      'Weekly 2-hour live sessions',
      'Hands-on projects and assignments',
      'Private community access',
      '1-on-1 coaching sessions' 
    ],mastery: [ 
      'Strategic digital transformation planning',
      'Business process automation and optimization',
      'Data-driven decision making and analytics',
      'Scalable system design and implementation',
      'Change management and team adoption' 
    ],outcomes: [ 
      'Reduce operational costs by 25-40%',
      'Increase team productivity by 50%+',
      'Build scalable systems for growth',
      'Gain competitive advantage through technology' 
    ],idealFor: 'Business owners and executives ready to modernize their operations',investment: '$2,497'},
    {icon: FiTarget,title: 'AI-Powered Marketing Certification',duration: '6-week accelerated program',format: [ 
      'Live workshops and case study analysis',
      'Real campaign implementation',
      'Peer collaboration and feedback',
      'Certification exam and portfolio review' 
    ],mastery: [ 
      'Strategic AI implementation for marketing',
      'Automated content creation and distribution',
      'Predictive analytics and customer insights',
      'Personalization at scale',
      'ROI measurement and optimization' 
    ],outcomes: [ 
      'Increase marketing efficiency by 60%+',
      'Improve campaign performance by 40%+',
      'Reduce content creation time by 70%',
      'Generate higher quality leads consistently' 
    ],idealFor: 'Marketing professionals and business owners focused on growth',investment: '$1,997'},
    {icon: FiZap,title: 'Business Automation Specialist Certification',duration: '10-week comprehensive program',format: [ 
      'Technical workshops and hands-on labs',
      'Real business automation projects',
      'Mentorship and expert guidance',
      'Professional certification credential' 
    ],mastery: [ 
      'Process analysis and optimization',
      'Workflow automation design',
      'Integration strategy and implementation',
      'Performance monitoring and improvement',
      'Team training and adoption strategies' 
    ],outcomes: [ 
      'Become a certified automation specialist',
      'Command premium consulting rates',
      'Help businesses save 30-50% on operational costs',
      'Build a valuable,in-demand skill set' 
    ],idealFor: 'Operations managers and consultants wanting specialized expertise',investment: '$2,997'} 
  ];

  const testimonials=[ 
    {name: 'Sarah M.',title: 'Marketing Director',quote: 'The AI-Powered Marketing Certification transformed how we approach campaigns. We\'ve increased our lead generation by 180% while reducing our workload by 40%.'},
    {name: 'Michael R.',title: 'Business Owner',quote: 'After completing the Digital Business Mastery program,we automated 70% of our administrative tasks and increased revenue by 45% in six months.'},
    {name: 'Jennifer L.',title: 'Operations Manager',quote: 'The Business Automation Specialist certification gave me the skills to save our company $200,000 annually in operational costs. I also got promoted and a 35% salary increase.'} 
  ];

  return ( 
    <div> 
      {/* Hero Section */} 
      <section className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 py-20"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"> 
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6"> 
            Master Modern Business Skills That Drive Real Results 
          </h1> 
          <p className="text-xl text-blue-100 max-w-4xl mx-auto mb-10"> 
            Professional training programs designed for business leaders who want to leverage cutting-edge strategies,automation,and growth techniques to accelerate their success. 
          </p> 
          <Link 
            to="#programs" 
            className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors" 
          > 
            Explore Training Programs 
          </Link> 
        </div> 
      </section> 

      {/* Problem Section */} 
      <section className="py-16 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"> 
              The Modern Business Skills Gap 
            </h2> 
            <p className="text-lg text-gray-600 max-w-4xl mx-auto mb-8"> 
              Today's business environment demands new skills that traditional education doesn't teach: 
            </p> 
          </div> 
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12"> 
            {[ 
              {title: 'Digital Strategy',description: 'Most leaders lack the knowledge to implement effective digital transformation'},
              {title: 'Automation Mastery',description: 'Businesses miss opportunities to save 20-40 hours per week through automation'},
              {title: 'AI Integration',description: 'Companies fall behind competitors who effectively leverage AI for growth'},
              {title: 'Scalable Systems',description: 'Leaders struggle to build systems that support sustainable growth'} 
            ].map((skill,index)=> ( 
              <div key={index} className="bg-gray-50 p-6 rounded-xl"> 
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{skill.title}</h3> 
                <p className="text-gray-600">{skill.description}</p> 
              </div> 
            ))} 
          </div> 
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 text-center"> 
            <p className="text-lg text-gray-700"> 
              <strong>Harvard Business Review reports</strong> that 87% of executives believe they have a skills gap,but only <span className="text-blue-600 font-semibold">25% have a clear plan to address it</span>. 
            </p> 
          </div> 
        </div> 
      </section> 

      {/* Solution Section */} 
      <section className="py-16 bg-gray-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"> 
              Practical Training That Transforms Businesses 
            </h2> 
            <p className="text-xl text-gray-600 max-w-4xl mx-auto"> 
              Our certification programs combine proven strategies with hands-on implementation 
            </p> 
          </div> 
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8"> 
            {[ 
              {icon: FiBook,title: 'Learn by Doing',description: 'Every program includes real-world projects you implement in your own business.'},
              {icon: FiUsers,title: 'Expert Instruction',description: 'Learn from practitioners who have successfully implemented these strategies across multiple industries.'},
              {icon: FiTarget,title: 'Ongoing Support',description: 'Access to community,resources,and continued learning opportunities.'},
              {icon: FiTrendingUp,title: 'Measurable Results',description: 'Track your progress with specific metrics and ROI measurements.'} 
            ].map((feature,index)=> ( 
              <div key={index} className="bg-white p-6 rounded-xl shadow-lg text-center"> 
                <div className="text-blue-600 mb-4 flex justify-center"> 
                  <SafeIcon icon={feature.icon} className="h-12 w-12" /> 
                </div> 
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{feature.title}</h3> 
                <p className="text-gray-600">{feature.description}</p> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Programs Section */} 
      <section id="programs" className="py-16 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              Professional Certification Programs 
            </h2> 
          </div> 
          <div className="space-y-16"> 
            {programs.map((program,index)=> ( 
              <div key={index} className="bg-gray-50 rounded-2xl p-8 lg:p-12"> 
                <div className="grid lg:grid-cols-3 gap-8"> 
                  <div className="lg:col-span-2"> 
                    <div className="flex items-center space-x-4 mb-6"> 
                      <div className="p-3 bg-blue-100 rounded-xl"> 
                        <SafeIcon icon={program.icon} className="h-8 w-8 text-blue-600" /> 
                      </div> 
                      <div> 
                        <h3 className="text-2xl font-bold text-gray-900">{program.title}</h3> 
                        <p className="text-blue-600 font-semibold">{program.duration}</p> 
                      </div> 
                    </div> 
                    <div className="mb-8"> 
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">What You'll Master:</h4> 
                      <ul className="space-y-2"> 
                        {program.mastery.map((skill,idx)=> ( 
                          <li key={idx} className="flex items-start space-x-3"> 
                            <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                            <span className="text-gray-700">{skill}</span> 
                          </li> 
                        ))} 
                      </ul> 
                    </div> 
                    <div className="mb-8"> 
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Program Format:</h4> 
                      <ul className="space-y-2"> 
                        {program.format.map((item,idx)=> ( 
                          <li key={idx} className="flex items-start space-x-3"> 
                            <SafeIcon icon={FiArrowRight} className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" /> 
                            <span className="text-gray-700">{item}</span> 
                          </li> 
                        ))} 
                      </ul> 
                    </div> 
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4"> 
                      <h4 className="font-semibold text-gray-900 mb-2">Ideal For:</h4> 
                      <p className="text-gray-700">{program.idealFor}</p> 
                    </div> 
                  </div> 
                  <div className="bg-white rounded-xl p-6 shadow-lg h-fit"> 
                    <div className="text-center mb-6"> 
                      <div className="text-3xl font-bold text-gray-900 mb-2">{program.investment}</div> 
                      <p className="text-gray-600">Complete Program</p> 
                    </div> 
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Expected Outcomes:</h4> 
                    <ul className="space-y-3 mb-6"> 
                      {program.outcomes.map((outcome,idx)=> ( 
                        <li key={idx} className="flex items-start space-x-3"> 
                          <SafeIcon icon={FiTrendingUp} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                          <span className="text-gray-700">{outcome}</span> 
                        </li> 
                      ))} 
                    </ul> 
                    <Link 
                      to="/book-consultation" 
                      className="block w-full text-center bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors" 
                    > 
                      Schedule Your Consultation 
                    </Link> 
                  </div> 
                </div> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Corporate Training Section */} 
      <section className="py-16 bg-gray-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"> 
              Corporate Training Solutions 
            </h2> 
            <p className="text-xl text-gray-600 max-w-3xl mx-auto"> 
              Transform your entire team with customized training designed for your specific industry and challenges. 
            </p> 
          </div> 
          <div className="grid lg:grid-cols-2 gap-12 items-center"> 
            <div> 
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Custom Training Programs for Your Organization</h3> 
              <div className="space-y-6"> 
                <div> 
                  <h4 className="text-lg font-semibold text-gray-900 mb-3">What's Included:</h4> 
                  <ul className="space-y-2"> 
                    {[ 
                      'Needs assessment and custom curriculum design',
                      'On-site or virtual training delivery',
                      'Hands-on workshops and implementation support',
                      'Progress tracking and performance measurement',
                      'Ongoing support and resource access' 
                    ].map((item,idx)=> ( 
                      <li key={idx} className="flex items-start space-x-3"> 
                        <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" /> 
                        <span className="text-gray-700">{item}</span> 
                      </li> 
                    ))} 
                  </ul> 
                </div> 
              </div> 
            </div> 
            <div className="bg-white p-8 rounded-xl shadow-lg"> 
              <h4 className="text-xl font-semibold text-gray-900 mb-6">Popular Corporate Programs:</h4> 
              <div className="space-y-4"> 
                {[ 
                  'Digital Transformation Leadership (C-Suite)',
                  'Marketing Automation Mastery (Marketing Teams)',
                  'Business Process Optimization (Operations Teams)',
                  'AI Integration Strategy (All Departments)' 
                ].map((program,idx)=> ( 
                  <div key={idx} className="flex items-center space-x-3 p-3 bg-gray-50 rounded-lg"> 
                    <SafeIcon icon={FiUsers} className="h-5 w-5 text-blue-600 flex-shrink-0" /> 
                    <span className="text-gray-700">{program}</span> 
                  </div> 
                ))} 
              </div> 
              <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg"> 
                <p className="text-gray-700"> 
                  <strong>Investment:</strong> Custom programs start at $15,000 for teams of 10-25 people 
                </p> 
              </div> 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* Success Stories Section */} 
      <section className="py-16 bg-white"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              Success Stories from Our Graduates 
            </h2> 
          </div> 
          <div className="grid md:grid-cols-3 gap-8"> 
            {testimonials.map((testimonial,index)=> ( 
              <div key={index} className="bg-gray-50 p-8 rounded-xl"> 
                <div className="flex items-center mb-4"> 
                  {[...Array(5)].map((_,i)=> ( 
                    <SafeIcon key={i} icon={FiStar} className="h-5 w-5 text-yellow-400" /> 
                  ))} 
                </div> 
                <blockquote className="text-gray-700 mb-6 italic"> 
                  "{testimonial.quote}" 
                </blockquote> 
                <div> 
                  <div className="font-semibold text-gray-900">{testimonial.name}</div> 
                  <div className="text-gray-600">{testimonial.title}</div> 
                </div> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* Investment Section */} 
      <section className="py-16 bg-gray-50"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
          <div className="text-center mb-12"> 
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"> 
              Program Investment & ROI 
            </h2> 
          </div> 
          <div className="grid md:grid-cols-2 gap-12 items-center"> 
            <div> 
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Individual Certification Programs</h3> 
              <div className="space-y-4 mb-8"> 
                <div className="flex justify-between items-center p-4 bg-white rounded-lg shadow"> 
                  <span className="font-semibold text-gray-900">Digital Business Mastery</span> 
                  <span className="text-blue-600 font-bold">$2,497</span> 
                </div> 
                <div className="flex justify-between items-center p-4 bg-white rounded-lg shadow"> 
                  <span className="font-semibold text-gray-900">AI-Powered Marketing</span> 
                  <span className="text-blue-600 font-bold">$1,997</span> 
                </div> 
                <div className="flex justify-between items-center p-4 bg-white rounded-lg shadow"> 
                  <span className="font-semibold text-gray-900">Business Automation Specialist</span> 
                  <span className="text-blue-600 font-bold">$2,997</span> 
                </div> 
              </div> 
              <div className="bg-green-50 border border-green-200 rounded-lg p-4"> 
                <h4 className="font-semibold text-green-800 mb-2">Payment Options:</h4> 
                <ul className="space-y-1 text-green-700"> 
                  <li>• Full payment (save 10%)</li> 
                  <li>• 3-month payment plan</li> 
                  <li>• Corporate financing available</li> 
                </ul> 
              </div> 
            </div> 
            <div className="bg-white p-8 rounded-xl shadow-lg"> 
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Corporate Training Investment</h3> 
              <div className="space-y-4 mb-6"> 
                <div className="border-b border-gray-200 pb-3"> 
                  <div className="flex justify-between items-center"> 
                    <span className="font-semibold text-gray-900">Team Training (10-25 people)</span> 
                  </div> 
                  <span className="text-gray-600">$15,000-45,000</span> 
                </div> 
                <div className="border-b border-gray-200 pb-3"> 
                  <div className="flex justify-between items-center"> 
                    <span className="font-semibold text-gray-900">Department-Wide (25-50 people)</span> 
                  </div> 
                  <span className="text-gray-600">$35,000-75,000</span> 
                </div> 
                <div className="pb-3"> 
                  <div className="flex justify-between items-center"> 
                    <span className="font-semibold text-gray-900">Organization-Wide (50+ people)</span> 
                  </div> 
                  <span className="text-gray-600">Custom pricing</span> 
                </div> 
              </div> 
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4"> 
                <h4 className="font-semibold text-blue-800 mb-2">ROI Guarantee:</h4> 
                <p className="text-blue-700"> 
                  Implement what you learn and see measurable business improvements within 90 days,or we'll provide additional coaching at no charge. 
                </p> 
              </div> 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* CTA Section */} 
      <section className="py-16 bg-blue-900"> 
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"> 
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6"> 
            Ready to Master the Skills That Drive Business Success? 
          </h2> 
          <p className="text-xl text-blue-100 mb-8 max-w-4xl mx-auto"> 
            Schedule a complimentary Program Consultation to discover which certification program is right for your goals. 
          </p> 
          <div className="bg-white/10 rounded-xl p-6 max-w-2xl mx-auto mb-10"> 
            <h3 className="text-xl font-semibold text-white mb-4">What You'll Get:</h3> 
            <ul className="text-left space-y-2"> 
              {[ 
                'Skills assessment and gap analysis',
                'Personalized program recommendations',
                'Career advancement strategy session',
                'Custom learning path design' 
              ].map((item,idx)=> ( 
                <li key={idx} className="flex items-start space-x-3"> 
                  <SafeIcon icon={FiCheck} className="h-5 w-5 text-green-300 mt-0.5 flex-shrink-0" /> 
                  <span className="text-blue-100">{item}</span> 
                </li> 
              ))} 
            </ul> 
          </div> 
          <Link 
            to="/book-consultation" 
            className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors" 
          > 
            Schedule Your Consultation 
          </Link> 
        </div> 
      </section> 
    </div> 
  );
}

export default BusinessTraining;